import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import ApiRest from "../../ayudas/apiRest"

const SidebarContent = props => {
    const ref = useRef();
    const apiRest = new ApiRest(props);

    const tieneRol = rolName => {
        let usuario = apiRest.getLS('du');
        if (usuario) {
            let rol = usuario.groups.find(rol => {
                return rol.name === rolName
            });
            return (rol !== undefined && rol !== null);
        }
        return false;
    }

    const activateParentDropdown = useCallback((item) => {
        item.classList.add("active")
        const parent = item.parentElement
        const parent2El = parent.childNodes[1]
        if (parent2El && parent2El.id !== "side-menu") {
            parent2El.classList.add("mm-show")
        }

        if (parent) {
            parent.classList.add("mm-active")
            const parent2 = parent.parentElement

            if (parent2) {
                parent2.classList.add("mm-show") // ul tag

                const parent3 = parent2.parentElement // li tag

                if (parent3) {
                    parent3.classList.add("mm-active") // li
                    parent3.childNodes[0].classList.add("mm-active") //a
                    const parent4 = parent3.parentElement // ul
                    if (parent4) {
                        parent4.classList.add("mm-show") // ul
                        const parent5 = parent4.parentElement
                        if (parent5) {
                            parent5.classList.add("mm-show") // li
                            parent5.childNodes[0].classList.add("mm-active") // a tag
                        }
                    }
                }
            }
            scrollElement(item);
            return false
        }
        scrollElement(item);
        return false
    }, []);

    // Use ComponentDidMount and ComponentDidUpdate method symultaniously
    useEffect(() => {
        const pathName = props.location.pathname

        new MetisMenu("#side-menu")
        let matchingMenuItem = null
        const ul = document.getElementById("side-menu")
        const items = ul.getElementsByTagName("a")
        for (let i = 0; i < items.length; ++i) {
            if (pathName === items[i].pathname) {
                matchingMenuItem = items[i]
                break
            }
        }
        if (matchingMenuItem) {
            activateParentDropdown(matchingMenuItem);
        }

    }, [props.location.pathname, activateParentDropdown])

    useEffect(() => {
        ref.current.recalculate()
    })

    function scrollElement(item) {
        if (item) {
            const currentPosition = item.offsetTop
            if (currentPosition > window.innerHeight) {
                ref.current.getScrollElement().scrollTop = currentPosition - 300
            }
        }
    }

    const getLinkText = (targetElement) => {
        const span = targetElement.querySelector('span');
        const linkElement = targetElement.tagName === 'A' ? targetElement : targetElement.closest('a');
        
        if (span && span.textContent) {
            return span.textContent.trim();
        }
        
        if (linkElement && linkElement.textContent) {
            return linkElement.textContent.replace(/(\r\n|\n|\r)/gm, "").trim();
        }        
        return 'Enlace Desconocido';
    };

    const handleLinkClick = useCallback(async (event) => {
        const target = event.currentTarget || event.target;
        const linkPath = target.getAttribute('href') || target.closest('a').getAttribute('href');
        const linkName = getLinkText(target);
        
        const registro = {
            componente: linkName, 
            ruta: linkPath,
        };
        
        try {
            await apiRest.post('/historialMenu', registro).then(resultado => {
                if (resultado.exitoso) {
                    console.log(`Evento de clic en "${linkName}" registrado exitosamente.`);
                } else {
                    console.log("No se puedo registrar el clic");
                }
            });            
        } catch (error) {
            console.error("Error al registrar el evento de clic:", error);
        }
    }, [apiRest]);

    return (
        <React.Fragment>

            <SimpleBar style={{ maxHeight: "100%" }} ref={ref} className="sidebar-menu-scroll">
                <div id="sidebar-menu" style={{ background: "red !important" }}>
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">{props.t("Menu")} </li>
                        <li>
                            <Link to="/#" className="waves-effect" onClick={handleLinkClick}>
                                <i className="uil-home-alt"></i>
                                <span>{props.t("Inicio")}</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/logout" className="waves-effect" onClick={handleLinkClick}>
                                <i className="uil-sign-out-alt"></i>
                                <span>{props.t("Salir")}</span>
                            </Link>
                        </li>

                        <li className="menu-title">{props.t("Apps")}</li>

                        {
                            apiRest.tienePermiso('menu_activos') ?
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fas fa-dolly-flatbed"></i>
                                        <span>{props.t("Activos")}</span>
                                    </Link>
                                    <ul className="sub-menu">
                                        {
                                            apiRest.tienePermiso('item_articulo_admin') ?
                                                <li>
                                                    <Link to="/articuloListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-clipboard"></i>
                                                        <span>{props.t("Artículos")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_articulos_entregados') ?
                                                <li>
                                                    <Link to="/tarjetaResponsabilidadAceptar" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-file-import"></i>
                                                        <span>{props.t("Artículos Entregados")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_articulos_aceptados') ?
                                                <li>
                                                    <Link to="/tarjetaResponsabilidadAceptados" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-clipboard-check"></i>
                                                        <span>{props.t("Artículos Aceptados")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_articulo_no_asignados') ?
                                                <li>
                                                    <Link to="/articuloNoAsignado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="far fa-folder-open"></i>
                                                        <span>{props.t("Artículos no Asignados")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_proveedor_admin') ?
                                                <li>
                                                    <Link to="/proveedorLista" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-edit"></i>
                                                        <span>{props.t("Proveedor")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_reporte_activos_master') ?
                                                <li>
                                                    <Link to="/reporteArticuloMaster" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-print"></i>
                                                        <span>{props.t("Reporte de Activos Master")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_articulo_admin') ?
                                                <li>
                                                    <Link to="/reporteArticuloUbicacion" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-building"></i>
                                                        <span>{props.t("Activos por Ubicación")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_reporte_historial_activos') ?
                                                <li>
                                                    <Link to="/reporteHistorialArticulo" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-print"></i>
                                                        <span>{props.t("Reporte Historial de Activos ")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_articulo_admin') ?
                                                <li>
                                                    <Link to="/historialImportacionArticulo" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-history"></i>
                                                        <span>{props.t("Historial Importación Masiva")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                                <li>
                                                    <Link to="/listaActivosEnsamble" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-wrench"></i>
                                                        <span>{props.t("Ensamble activos")}</span>
                                                    </Link>
                                                </li>
                                                {
                                                    apiRest.getRol() || apiRest.getRolDeUsuario('ROL_RESPONSABLE_DEPARTAMENTO') ?
                                                    <li>
                                                       <Link to="/ensamblePorDepartamento" className="waves-effect" onClick={handleLinkClick}>
                                                           <i className="fa fa-bell"></i>
                                                           <span>{props.t("Lista de Activos para Ensamblar")}</span>
                                                       </Link>
                                                    </li>
                                                    : ""
                                                }
                                        {
                                            apiRest.tienePermiso('item_trazabilidad_activos') ?
                                                <li>
                                                    <Link to="/reporteHistorialArticuloAsignado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-chalkboard-teacher"></i>
                                                        <span>{props.t("Trazabilidad de Activos")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_tarjeta_responsabilidad') ?
                                                <li>
                                                    <Link to="/tarjetaResponsabilidadListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="far fa-address-card"></i>
                                                        <span>{props.t("Tarjetas de Responsabilidad")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_area_trabajo') ?
                                                <li>
                                                    <Link to="/areaTrabajo" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-edit"></i>
                                                        <span>{props.t("Ubicación Area Trabajo")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                    </ul>
                                </li>
                                : ""
                        }

                        {
                            apiRest.tienePermiso('menu_catalogos') ?
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fas fa-building"></i>
                                        <span>{props.t("Catálogos")}</span>
                                    </Link>
                                    <ul className="sub-menu">
                                        {
                                            apiRest.tienePermiso('item_categoria') ?
                                                <li>
                                                    <Link to="/categoriaListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-users"></i>
                                                        <span>{props.t("Categorías")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_colaborador') ?
                                                <li>
                                                    <Link to="/colaboradorListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-users"></i>
                                                        <span>{props.t("Colaboradores")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_departamento_area') ?
                                                <li>
                                                    <Link to="/departamentoAreaListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fab fa-houzz"></i>
                                                        <span>{props.t("Depa. - Area")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_departamento_municipio') ?
                                                <li>
                                                    <Link to="/territorioListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-map-marked" />
                                                        <span>{props.t("Depa. / Muni.")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_empresa') ?
                                                <li>
                                                    <Link to="/empresaListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-city"></i>
                                                        <span>{props.t("Empresas")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_escolaridad') ?
                                                <li>
                                                    <Link to="/escolaridadListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-book-reader"></i>
                                                        <span>{props.t("Escolaridades")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_ubicacion') ?
                                                <li>
                                                    <Link to="/ubicacionListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-map-marker"></i>
                                                        <span>{props.t("Ubicación")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_puesto') ?
                                                <li>
                                                    <Link to="/puestoListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-sort-amount-up"></i>
                                                        <span>{props.t("Puestos")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                    </ul>
                                </li>
                                : ""
                        }

                        {
                            apiRest.tienePermiso('menu_mesa_servicio') ?
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fas fa-list-alt"></i>
                                        <span>{props.t("Mesa de Servicio")}</span>
                                    </Link>
                                    <ul className="sub-menu">
                                        {
                                            apiRest.tienePermiso('item_calendario') ?
                                                <li>
                                                    <Link to="/calendario" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="uil-calender"></i>
                                                        <span>{props.t("Calendario")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }                                        
                                        {
                                            apiRest.tienePermiso('item_solicitudes_admin') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitudAdmin' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-inbox"></i>
                                                        {/*<span>{props.t("Listado de Solicitudes")}</span>*/}
                                                        <span>{props.t("Solicitudes Recibidas")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {/*
                                            apiRest.tienePermiso('item_solicitud_nueva') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitud' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-plus"></i>
                                                        <span>{props.t("Nueva Solicitud")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        */}
                                        {
                                            apiRest.tienePermiso('item_solicitudes_nueva') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitudNueva' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-street-view"></i>
                                                        <span>{props.t("Mis Solicitudes")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }                                                                               
                                        {
                                            apiRest.tienePermiso('item_asignar') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitudAsignar' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="far fa-hand-point-right"></i>
                                                        <span>{props.t("Asignar Solicitud")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_emergencias') ?
                                                <li>
                                                    <Link to={{ pathname: "/solicitudEmergencias" }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i class="fas fa-bullhorn"></i>
                                                        <span style={{color: "#f5da9d"}}>{props.t("Asignar Emergencias")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_concluir') ?
                                                <li>
                                                    <Link to={{ pathname: "/solicitudConcluir" }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-check"></i>
                                                        <span>{props.t("Concluir Solicitud")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_concluir_masivo') ?
                                                <li>
                                                    <Link to={{ pathname: "/solicitudConcluirMasivo" }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-tasks"></i>
                                                        <span>{props.t("Concluir Solicitud Masivo")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_calificar') ?
                                                <li>
                                                    <Link to={{ pathname: "/solicitudCalificar" }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="uil-favorite" />
                                                        <span>{props.t("Calificar Solicitud")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_finalizadas') ?
                                                <li>
                                                    <Link to={{ pathname: "/solicitudFinalizada" }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-list-ol"></i>
                                                        <span>{props.t("Solic. Finalizadas")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_enviados_departamento') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitudDelDepartamento' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-mail-bulk"></i>
                                                        <span>{props.t("Enviados por el Departamento")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }                                        
                                        {/*
                                            apiRest.tienePermiso('item_carga_masiva') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitudImportarExcel' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-file-excel"></i>                                                        
                                                        <span>{props.t("Carga Masiva Excel")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        */}
                                        {
                                            apiRest.tienePermiso('item_solicitudes_admin') ?
                                                <li>
                                                    <Link to={{ pathname: '/solicitudArchivado' }} className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-archive"></i>
                                                        {/*<span>{props.t("Listado de Solicitudes")}</span>*/}
                                                        <span>{props.t("Solicitudes Archivados")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.getRol() ?
                                                <li>
                                                    <Link to="/listaDeSolicitudesAutomaticas" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-list-alt"></i>
                                                        <span>{props.t("Solicitudes Automaticas")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {/*
                                            <li>
                                                <Link to={{ pathname: '/programarSolicitud' }} className="waves-effect" onClick={handleLinkClick}>
                                                    <i className="fas fa-stopwatch"></i>
                                                    <span>{props.t("Programar Solicitud Concurrente")}</span>
                                                </Link>
                                            </li>
                                        */}
                                        {
                                            apiRest.tienePermiso('item_material') ?
                                                <li>
                                                    <Link to="/materialListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="far fa-list-alt"></i>
                                                        <span>{props.t("Material")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_tipo_solicitud') ?
                                                <li>
                                                    <Link to="/tipoSolicitudListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-tasks"></i>
                                                        <span>{props.t("Tipo de solicitud")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_proyecto') ?
                                                <li>
                                                    <Link to="/proyectoListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-project-diagram"></i>
                                                        <span>{props.t("Proyecto")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }

                                        {
                                            apiRest.tienePermiso('menu_reportes_servicio') ?
                                                <li>
                                                    <Link to="/#" className="has-arrow waves-effect">
                                                        <i className="fas fa-folder-plus"></i>
                                                        <span>{props.t("Reportes")}</span>
                                                    </Link>
                                                    <ul className="sub-menu">
                                                        <li>
                                                            <Link to="/#" className="has-arrow waves-effect">
                                                                <i className="fas fa-folder-plus"></i>
                                                                <span>{props.t("Gráficas")}</span>
                                                            </Link>
                                                            <ul className="sub-menu">
                                                                {
                                                                    apiRest.tienePermiso('item_grafica_tipo_solicitud') ?
                                                                        <li>
                                                                            <Link to="/graficaTipoSolicitud" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-desktop"></i>
                                                                                <span>{props.t("Tipo de Solicitud")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                                {
                                                                    apiRest.tienePermiso('item_grafica_solicitud_por_estado') ?
                                                                        <li>
                                                                            <Link to="/graficar" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-desktop"></i>
                                                                                <span>{props.t("Solicitudes por Estado")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                                {
                                                                    apiRest.tienePermiso('item_grafica_calificacion') ?
                                                                        <li>
                                                                            <Link to="/graficaCalificacion" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-desktop"></i>
                                                                                <span>{props.t("Solicitudes por Calificación")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                                {
                                                                    apiRest.tienePermiso('item_grafica_horas') ?
                                                                        <li>
                                                                            <Link to="/graficaHoras" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-desktop"></i>
                                                                                <span>{props.t("Tiempo de Solicitudes")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            <Link to="/#" className="has-arrow waves-effect">
                                                                <i className="fas fa-folder-plus"></i>
                                                                <span>{props.t("Reportes")}</span>
                                                            </Link>
                                                            <ul className="sub-menu">
                                                                {
                                                                    apiRest.tienePermiso('item_reporte_solicitudes') ?
                                                                        <li>
                                                                            <Link to="/reporte" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-book"></i>
                                                                                <span>{props.t("De Solicitudes")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                                {
                                                                    apiRest.tienePermiso('item_reporte_trabajo') ?
                                                                        <li>
                                                                            <Link to="/reporteFinalizado" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-book"></i>
                                                                                <span>{props.t("De Trabajo")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                                {
                                                                    apiRest.tienePermiso('item_recepcion_solicitud') ?
                                                                        <li>
                                                                            <Link to="/reporteRecepcionSolicitud" className="waves-effect" onClick={handleLinkClick}>
                                                                                <i className="uil-book"></i>
                                                                                <span>{props.t("Recepción de Solicitudes")}</span>
                                                                            </Link>
                                                                        </li>
                                                                        : ""
                                                                }
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                                : ""
                                        }
                                    </ul>
                                </li>
                                : ""
                        }

                        {
                            apiRest.tienePermiso('generar_qr') ?
                                <li>
                                    <Link to="/generadorQR" onClick={handleLinkClick}>
                                        <i className="fas fa-qrcode"></i>
                                        <span>{props.t("Generador QR")}</span>
                                    </Link>
                                </li>
                                : ""
                        }

                        {
                            apiRest.tienePermiso('menu_seguridad') ?
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fas fa-folder-plus"></i>
                                        <span>{props.t("Seguridad")}</span>
                                    </Link>
                                    <ul className="sub-menu">
                                        {
                                            apiRest.tienePermiso('item_rol') ?
                                                <li>
                                                    <Link to="/rolListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-list-ul"></i>
                                                        <span>{props.t("Roles")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_usuario') ?
                                                <li>
                                                    <Link to="/usuarioListado" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="uil-user-circle"></i>
                                                        <span>{props.t("Usuarios")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                        {
                                            apiRest.tienePermiso('item_usuario') ?
                                                <li>
                                                    <Link to="/reporteHistorialMenu" className="waves-effect" onClick={handleLinkClick}>
                                                        <i className="fas fa-stopwatch"></i>
                                                        <span>{props.t("Reporte Historial Menú")}</span>
                                                    </Link>
                                                </li>
                                                : ""
                                        }
                                    </ul>
                                </li>
                                : ""
                        }

                    </ul>
                </div>
            </SimpleBar>
        </React.Fragment >
    )
}

SidebarContent.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))